/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

/**
 * Divider renders a horizontal divider line with optional width.
 * @param width - Optional width of the divider in pixels.
 */
const Divider: FunctionComponent<{ width?: number }> = ({ width }) => {
    return <div className="uikit divider" style={{ width }} />;
};

export default Divider;
